export default __webpack_public_path__ + "static/media/morse_intro_nl.5e17eaa3.mp3";